export default __webpack_public_path__ + "static/media/562.1faf6753.gif";